import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-data-row',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="data-row">
      <span class="data-row-label">{{ label() }}</span>
      <span class="data-row-value">{{ value() }}</span>
    </div>
  `,
  styles: [`
    .data-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 3rem;
      padding: 0.5rem 0;
      border-bottom: 0.0625rem solid var(--color-border);
    }
    .data-row:last-child {
      border-bottom: none;
    }
    .data-row-label {
      font-size: 0.96rem;
      font-weight: 500;
      color: var(--color-text-secondary);
    }
    .data-row-value {
      font-size: 0.97rem;
      font-weight: 600;
      color: var(--color-text-primary);
      text-align: right;
    }
  `],
})
export class DataRowComponent {
  label = input('');
  value = input('');
}
